import React from "react";
import ReactDOM from "react-dom";
import "./assets/css/index.less";
import Main from "./routes/Main";
import { BrowserRouter } from "react-router-dom";
import "antd/dist/antd.less";
import "@ant-design/flowchart/dist/index.css";
import { Provider } from "react-redux";
import { Store } from "./app/Store";

const store = Store;

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
